import React, { forwardRef } from 'react'

import Box, { type BoxProps } from '../box'

export type ColumnProps = BoxProps

const Column = forwardRef<HTMLElement, ColumnProps>((props, ref) => (
  <Box ref={ref} flexDirection='column' flex='1 0 auto' {...props} />
))
Column.displayName = 'Column'

export default Column
